import { useMemo } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import HeroSection from "./components/HeroSection";
import ChannelDirectory from "./components/ChannelDirectory";
import HotSection from "./components/HotSection";
import LatestSection from "./components/LatestSection";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/gossip";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "看料社",
        alternateName: "看料爆料专区",
        url: "https://sdyjh.cn/",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://sdyjh.cn/channels?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "看料社",
        url: "https://sdyjh.cn/",
        description: "看料爆料频道入口聚合门户，整理娱乐爆料版块、频道与栏目入口。",
        email: "hi@kanliaoshe.example.com",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
    [],
  );

  useSeo({
    title: "看料爆料 - 看料爆料专区、版块、频道入口大全",
    description:
      "看料爆料专区集中整理娱乐爆料版块、频道与栏目入口，热门瓜料分类清晰，想找哪类瓜点都能按板块快速翻到，是中文网友常用的爆料频道入口导航。",
    keywords: "看料爆料,看料爆料专区,看料爆料版块,看料爆料频道,看料爆料栏目",
    canonicalPath: "/",
    ogType: "website",
    jsonLd,
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <ChannelDirectory />
        <HotSection />
        <LatestSection />
        <FaqSection />
        <BrandSection />

        <section className="w-full">
          <div className="w-full px-4 md:px-6 py-14 md:py-20">
            <div className="rounded-lg bg-primary-500 px-6 py-10 md:px-14 md:py-16 text-center">
              <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 leading-snug">
                有线索想提供？想了解我们的内容原则？
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-50/85 max-w-2xl mx-auto leading-relaxed">
                欢迎把你知道的公开线索整理后发给我们，也可以先看看我们整理内容时的判断标准，再决定要不要提交。
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/contact"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap bg-background-50 text-primary-700 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-send-line" />
                  前往联系我们
                </Link>
                <Link
                  to="/channels"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap bg-primary-600 text-background-50 hover:bg-primary-700 border border-background-50/30 transition-colors cursor-pointer"
                >
                  <i className="ri-compass-3-line" />
                  浏览频道入口
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}